import Footer from './Footer';
import Navigation from './Navigation';
import Pinned from './Pinned';
import { Container } from './styled';
import { SidebarProps } from './types';

function Sidebar({ selectedSection }: SidebarProps) {
  return (
    <Container sx={{ display: { sm: 'none', xs: 'none', md: 'flex' } }}>
      <Navigation selectedSection={selectedSection} />
      <Pinned />
      <Footer />
    </Container>
  );
}

export default Sidebar;
